module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1C5JwkK/tc-custom/9781439669303.jpg?1705026246095",
      "alt": "This image is the cover for the book Murder in Stark County, Ohio, Murder & Mayhem"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Murder in Stark County, Ohio, Murder & Mayhem\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Rendered in painstaking detail, accounts of high-profile killings and courtroom drama filled the pages of Stark County's early newspapers. The triple hanging of three teenage boys in 1880 seized the attention of the entire community. When George Saxton, notorious womanizer and President McKinley's brother-in-law, was shot dead on the front lawn of his widowed lover in 1898, the whole nation looked on. For the brutal slaying of his wife, James Cornelius became the first local prison inmate executed in the electric chair in 1906. Using contemporary local newspaper accounts, author Kim Kenney tells the story of eight Stark County murders, unfolding the grisly details while honoring the lives cut short by violence.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kimberly A. Kenney\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kim Kenney earned her Master of Arts degree in history museum studies at the Cooperstown Graduate Program in New York. She became curator of the McKinley Presidential Library & Museum in 2001 and was promoted to assistant director in 2017. She has authored eight books, and her work has appeared in the Public Historian, White House History, The Repository, the Boston Globe, Aviation History and Mused. Kim has appeared on The Daily Show, First Ladies: Influence & Images and Mysteries at the Museum. Her program \"The 1918 Influenza Pandemic\" was featured on C-SPAN's series American History TV.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0